import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import {
  Container,
  Title,
  SidebarWrapper,
  Sidebar,
  SidebarTitle,
} from './styles';

export const FilterCertificates = () => {
  const options = [
    {
      value: 'Arquivos recentes',
      label: 'Arquivos recentes',
    },
  ];
  return (
    <Container>
      <Title />
      <SidebarWrapper>
        <SidebarTitle />
        <Sidebar>
          <ul>
            {options.map(option => (
              <li aria-hidden="true" key={option.value} className="selected">
                <div className="content">
                  {option.label}
                  <ArrowRightIcon />
                </div>
              </li>
            ))}
          </ul>
        </Sidebar>
      </SidebarWrapper>
    </Container>
  );
};
